import { useRef, useState } from 'react';
import { Calendar16 } from 'ui/icons/aurora/16px/Calendar16';
import { noop } from 'utils/noop';
import { RELATIVE_DATE_PLACEHOLDER, selectInputText } from '../helpers';
import { InputWrapper, StyledRelativeDateInput } from './DatePickerInput.styles';

type RelativeDateInputProps = {
  /** Unique id of input */
  id: string;
  /** Whether input is read only */
  isReadOnly?: boolean;
  /** Applies disabled styles for a disabled input */
  isDisabled?: boolean;
  /** Function to be run when the date is updated */
  onDateChange?: (str: string) => void;
  /** Date to display */
  date: string;
  /** Custom/override placeholder text */
  placeholder?: string;
  /** Whether input value has error */
  hasError?: boolean;
};

export const RelativeDateInput = ({
  id,
  date,
  isReadOnly,
  onDateChange = noop,
  placeholder = RELATIVE_DATE_PLACEHOLDER,
  isDisabled = false,
  hasError = false,
}: RelativeDateInputProps) => {
  const inputRef = useRef(null);

  const [isValid, setIsValid] = useState(!hasError);
  const [isFocused, setIsFocused] = useState(false);

  const validateDate = () => {
    // TODO: write validation function
    // setIsValid(checkIsValid);
    // setIsFocused(false);
  };

  const handleFocus = () => {
    selectInputText(inputRef);
    setIsFocused(true);
  };

  const parseDate = (val: string) => {
    // TODO: write parsing function
    // setIsValid()
    return val;
  };

  return (
    <InputWrapper isValid={isValid && !hasError} isFocused={isFocused} isDisabled={isDisabled}>
      <Calendar16 />
      <StyledRelativeDateInput
        id={id}
        value={parseDate(date || placeholder)}
        type="text"
        ref={inputRef}
        placeholder={placeholder}
        data-test={`${id}${isValid ? '' : '-invalid'}`}
        tabIndex={0}
        onChange={(e) => onDateChange(e.target.value)}
        onBlur={validateDate}
        onFocus={handleFocus}
        readOnly={isReadOnly}
        disabled={isReadOnly}
      />
    </InputWrapper>
  );
};
